"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations.validations;
  }
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.join.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _formElements = require("@evidation/form-elements");

var _components = require("../fileUpload/components");

var _styles = require("./styles");

var _constants = require("../../constants");

var _validations = require("./validations");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FILE_NOT_PROCESSED = function FILE_NOT_PROCESSED(message) {
  return "There was an error processing the file: ".concat(message, ".");
};

;

var readFile = function readFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onabort = function () {
      return reject('File reading was aborted');
    };

    reader.onerror = function () {
      return reject('File reading has failed');
    };

    reader.onload = function () {
      var result = reader.result;
      resolve({
        file: file,
        result: result
      });
    };

    reader.readAsText(file);
  });
};

var TextAreaFile = function TextAreaFile(_ref) {
  var _input$value;

  var labelStyle = _ref.labelStyle,
      inputStyle = _ref.inputStyle,
      label = _ref.label,
      description = _ref.description,
      required = _ref.required,
      meta = _ref.meta,
      input = _ref.input,
      maxSize = _ref.maxSize,
      validFileTypes = _ref.validFileTypes,
      defaultValue = _ref.defaultValue,
      _ref$dataTransformati = _ref.dataTransformation,
      dataTransformation = _ref$dataTransformati === void 0 ? function (data) {
    return data;
  } : _ref$dataTransformati,
      _ref$useObjectValue = _ref.useObjectValue,
      useObjectValue = _ref$useObjectValue === void 0 ? true : _ref$useObjectValue;

  var _useState = (0, _react.useState)(((_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value[input.name]) || defaultValue || ''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      studyData = _useState2[0],
      setStudyData = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var types = validFileTypes.map(function (_ref2) {
    var mime = _ref2.mime;
    return mime;
  });
  var acceptTypes = validFileTypes.map(function (_ref3) {
    var extension = _ref3.extension;
    return extension.toUpperCase();
  }).join(', ');

  var updateStudyData = function updateStudyData(value) {
    var fileData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
      var data = dataTransformation(value);
      setStudyData(value);
      input.onChange(useObjectValue ? _objectSpread((0, _defineProperty2["default"])({}, input.name, data), fileData) : data);
      input.onBlur();
      setError(null);
    } catch (e) {
      setError(FILE_NOT_PROCESSED(e.message));
    }
  };

  var getFileData = function getFileData(file) {
    var _ref4;

    return _ref4 = {}, (0, _defineProperty2["default"])(_ref4, "".concat(input.name, "_file_name"), file.name), (0, _defineProperty2["default"])(_ref4, "".concat(input.name, "_file_size"), file.size), (0, _defineProperty2["default"])(_ref4, "".concat(input.name, "_file_type"), file.type), _ref4;
  };

  var handleOnDrop = function handleOnDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles.length) {
      var _acceptedFiles = (0, _slicedToArray2["default"])(acceptedFiles, 1),
          file = _acceptedFiles[0];

      return readFile(file).then(function (_ref5) {
        var result = _ref5.result,
            file = _ref5.file;
        setError(null);
        updateStudyData(result, getFileData(file));
      })["catch"](setError);
    }

    if (!acceptedFiles.length && rejectedFiles.length) {
      var _rejectedFiles = (0, _slicedToArray2["default"])(rejectedFiles, 1),
          _file = _rejectedFiles[0];

      input.onChange(_objectSpread((0, _defineProperty2["default"])({}, input.name, studyData), getFileData(_file)));
      input.onBlur();
    }
  };

  (0, _react.useEffect)(function () {
    var touched = meta.touched,
        validationError = meta.error;

    if (touched && validationError) {
      setError(validationError);
    }
  }, [meta, setError]);
  var clickHereStr = 'Click to select file, or drop file here.';
  var acceptedTypesStr = "Accepted file formats: ".concat(acceptTypes);
  var idStr = "t-".concat(input.name);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    labelStyle: labelStyle,
    label: label,
    required: required
  }, /*#__PURE__*/_react["default"].createElement(_formElements.TextareaInput, {
    id: idStr,
    "data-test-id": "textarea-testid",
    inputStyle: inputStyle,
    value: studyData,
    onChange: function onChange(_ref6) {
      var target = _ref6.target;
      return updateStudyData(target.value);
    }
  })), error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), /*#__PURE__*/_react["default"].createElement(_components.UploadingOverlay, {
    active: meta.submitting,
    loadingText: "Uploading file"
  }, /*#__PURE__*/_react["default"].createElement(_styles.DropzoneContainer, null, /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
    id: "file-dropzone",
    style: {},
    accept: types,
    onDrop: handleOnDrop,
    maxSize: maxSize,
    multiple: false
  }, /*#__PURE__*/_react["default"].createElement(_styles.DropzoneText, null, clickHereStr), /*#__PURE__*/_react["default"].createElement(_styles.DropzoneText, null, acceptedTypesStr)))), description && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    labelStyle: labelStyle,
    label: description
  }));
};

TextAreaFile.propTypes = {
  maxSize: _propTypes["default"].number,
  validFileTypes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    extension: _propTypes["default"].string.isRequired,
    mime: _propTypes["default"].string.isRequired
  }))
};
TextAreaFile.defaultProps = {
  maxSize: _constants.defaultMaxFileSize,
  validFileTypes: [{
    extension: 'json',
    mime: 'application/json'
  }]
};
var _default = TextAreaFile;
exports["default"] = _default;